"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _reactRedux = require("react-redux");
var _ApiKeysSidePaneButtonComponent = _interopRequireDefault(require("./ApiKeysSidePaneButtonComponent"));
var _sidePaneActions = require("../../../../redux/actions/sidePaneActions");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
var mapDispatchToProps = {
  openApiKeysSidePane: _sidePaneActions.openApiKeysSidePane
};
var _default = exports["default"] = (0, _reactRedux.connect)(null, mapDispatchToProps)(_ApiKeysSidePaneButtonComponent["default"]);